<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-06 10:51:53
 * @Description: 数据管理
 * @FilePath: \web\src\components\DataManagement\institutionManagement\institutionManagement.vue
-->
<template>
  <div class="institution-management-wrap">
    <div class="left-tree-main">
      <a-button type="primary" size="small" class="tree-add-btn" @click="() => openOrgModal()">新增</a-button>
      <a-tree class="org-tree" :tree-data="orgTree" style="color: #fff"
        :replaceFields="{ children: 'children', title: 'name', key: 'id', parentId: 'parentId', sortNum: 'sortNum', reportTypes: 'reportTypes', areaIds: 'areaIds' }"
        @select="onSelectTree">
        <template #title="{ id, name, parentId, sortNum, reportTypes, areaIds, mineralsIds }">
          <a-dropdown :trigger="['contextmenu']">
            <span>{{ name }}</span>
            <template #overlay>
              <a-menu
                @click="({ key: menuKey }) => onContextMenuClick(id, menuKey, name, parentId, sortNum, reportTypes, areaIds, mineralsIds)">
                <a-menu-item key="1">编辑机构</a-menu-item>
                <a-menu-item key="2" style="color: red">删除机构</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tree>
    </div>
    <div class="role-management-main">
      <div class="search-container">

        <div class="search">
          <!-- S 用户权限 -->
          <!-- <div class="search-item" style="width:3rem">
          <div class="search-item-text">用户权限：</div>
          <a-select
            class="user-role-select"
            v-model:value="requestParams.userRole"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          >
            <a-select-option v-for="item in roleList" :key="item.roleName">
              {{ item.description }}
            </a-select-option>
            <template #suffixIcon>
              <CaretDownOutlined />
            </template>
          </a-select>
        </div> -->
          <!-- E 用户权限 -->
          <!-- S 用户名 -->
          <div class="search-item">
            <div class="search-item-text">用户名：</div>
            <a-input class="user-name-input" v-model:value="requestParams.username" />
          </div>
          <!-- E 用户名 -->
          <!-- <div class="search-item" style="width:3.5rem">
          <div class="search-item-text">组织机构：</div>
          <a-tree-select
            v-model:value="requestParams.orgId"
            show-search
            style="width: 100%"
            :dropdownStyle="{height: '4rem'}"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            placeholder="请选择"
            :treeData="orgTree"
            :replaceFields="{label: 'name', key: 'id',value: 'id' }"
            allow-clear
            tree-default-expand-all
          >
          </a-tree-select>
        </div> -->
          <!-- 组织机构 -->
          <div class="btn-wrapper">
            <div class="reset-btn btn-item" @click="resetSearch">重置</div>
            <div class="search-btn btn-item" @click="submitSearch()">查询</div>
          </div>
        </div>

        <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
          <div class="crud-item" @click="add()">新增</div>
          <!-- <div
          class="crud-item"
          @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'"
        >
          删除
        </div> -->

          <!-- <div
          class="crud-item"
          @click="selectDownload()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'"
        >
          导出
        </div> -->
        </div>
      </div>

      <a-table rowKey="id" class="management-table" :dataSource="userPages" :loading="userPagesLoading"
        :columns="columns" @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
        <template #serial="{ index }">{{ index + 1 }}</template>
        <!-- 单位类型 -->
        <template #orgType="{ record }">
          {{ record.sysOrg?.orgType }}
        </template>
        <!-- 单位名称 -->
        <template #name="{ record }">
          {{ record.sysOrg?.name }}
        </template>
        <!-- 行业类型 -->
        <template #tradeType="{ record }">
          {{ record.sysOrg?.tradeType }}
        </template>
        <template #integral="{ record }">
          {{ record.integral || '-' }}
        </template>

        <template #sysRoleList="{ record }">
          {{ userRole(record) }}
        </template>
        <template #status="{ record }">
          {{ lockJsons[record.status] || '无效值' }}
        </template>
        <template #action="{ record }">
          <section class="action-icons">
            <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option"
              @click="item.click(record)">
            </i>
            <i v-if="record.status === 'NORMAL'" v-bind="{
              style: 'color: rgb(255, 200, 120)',
              class: 'iconfont icon-suoding',
              title: '锁定',
            }" @click="lockAccount(record)">
            </i>
            <i v-if="record.status !== 'NORMAL'" v-bind="{
              style: 'color: rgb(255, 200, 120)',
              class: 'iconfont icon-jiesuo',
              title: '解锁',
            }" @click="unlockAccount(record)">
            </i>
          </section>
        </template>
      </a-table>

      <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
        <template v-slot:main>
          <AddOrg v-if="confirmModalConf.modalType === 'addOrg' || confirmModalConf.modalType === 'editOrg'"
            :modalType="confirmModalConf.modalType" :formState="orgFormState" :orgTree="orgTree"
            :mineralIdList="mineralIds" ref="orgFormRef" />
          <AddUser v-if="confirmModalConf.modalType === 'add' || confirmModalConf.modalType === 'edit'"
            :modalType="confirmModalConf.modalType" :formState="formState" :orgTree="orgTree" :roleList="roleList"
            ref="formRef" />
          <PsdReset v-if="confirmModalConf.modalType === 'psdRest'" :modalType="confirmModalConf.modalType"
            :formState="psdFormState" :orgTree="orgTree" :roleList="roleList" ref="psdRef" />
          <!-- <section v-if="confirmModalConf.modalType === 'roleEdit'">
          用户权限：
          <a-select
            class="user-role-select"
            mode="multiple"
            v-model:value="confirmModalConf.sysRoleIdList"
          >
            <a-select-option v-for="item in roleList" :key="item.roleId">
              {{ item.description }}
            </a-select-option>
            <template #suffixIcon>
              <CaretDownOutlined />
            </template>
    </a-select>
    </section> -->
        </template>
      </Modal>
      <!-- / 操作弹出框 -->
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, createVNode, } from 'vue';
import { useStore, } from 'vuex';
import { message, Modal as ModalAnt, } from 'ant-design-vue';
import Modal from '@/components/lib/Modal/modal1.vue';
import { GET_ROLE_LIST, GET_USER_LIST_PAGE, } from '@/store/modules/actions/roleManagement';
import { removeUserApi, userAddApi, userUpdateApi, userRoleAllocateApi, } from '@/api/dataManagement/roleManagement';
import { getOrgTreeApi, deleteOrgTreeApi, addOrgTreeNode, editOrgTreeNode, } from '@/api/dataManagement/orgManage';
import { CaretDownOutlined, ExclamationCircleOutlined, } from '@ant-design/icons-vue';
import { encrypt } from "@/utils/aes";
import config from '@/config/config';
import tableConfig from './tableConfig.js';
import AddUser from './add.vue';
import AddOrg from './addOrg.vue';
import PsdReset from './psdReset.vue';

const columns = tableConfig;

// 用户权限--超级管理员、管理员、普通用户
const userRoleList = [
  { key: '1', name: '超级管理员', },
  { key: '2', name: '管理员', },
  { key: '3', name: '普通用户', },
];
// 锁定状态
const lockJsons = {
  PROHIBIT: '错误锁定',
  LOCKED: '过期锁定',
  NORMAL: '正常',
  EXCEPTION: 'IP异常'
};
const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const userManagementState = computed(() => state.roleManagement);
const { requestParams, userPages, totalCount, userPagesLoading, roleList, } = toRefs(
  userManagementState.value
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'roleManagement'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'roleManagement'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id
const orgTree = ref([]); // 组织机构数据
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['8', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  selectValue: [],
  modalType: '',
  sysRoleIdList: [],
});

let formState = ref({
});
const mineralIds = ref([]);

let psdFormState = ref({});

let orgFormState = ref({});
const orgFormRef = ref();
const formRef = ref();
const psdRef = ref();
const addUserOption = reactive({
  btnType: '',
});

const userRole = (record) => {
  const ll = [];

  if (record.sysRoleList) {
    record.sysRoleList.forEach(item => ll.push(item.description));
  }

  return ll.toString();
};

/**
 * @description 检索查询事件
 */
const submitSearch = () => {
  commit(null, 'setRequestParams', { page: 1, size: 8, });
  dispatch(null, GET_USER_LIST_PAGE);
};

/**
 * @description 检索重置事件
 */
const resetSearch = () => {
  commit(null, 'clear');
  submitSearch();
};

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows, 'onSelect');
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows, 'onSelectAll');
  },
};

/**
 * @description 单行数据详情跳转
 */
const detailRecord = (record) => {
  const { id, } = record;
};

/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_USER_LIST_PAGE);
};

/* 右键 */
const onContextMenuClick = (treeKey, menuKey, name, parentId, sortNum, reportTypes, areaIds, mineralList) => {
  if (menuKey === '2') {
    ModalAnt.confirm({
      title: () => createVNode('div', { style: 'color: black;', }, `删除机构（${name}）`),
      icon: () => createVNode(ExclamationCircleOutlined),
      content: () => createVNode('div', { style: 'color:red;', }, `确认执行此操作?`),
      onOk() {
        delOrgTreeNode(treeKey);
      },
      onCancel() {
        console.log('Cancel');
      },
      class: 'test',
    });
  } else {
    const mineralListStrinng = mineralList.map(String);

    orgFormState.value = {
      sortNum,
      parentId,
      name,
      reportTypes,
      areaIds,
      id: treeKey,
      mineralIds: mineralListStrinng || [],
    };
    mineralIds.value = mineralListStrinng || [];
    openEditOrgModal();
  }
};

/* 点击组织机构 */
const onSelectTree = (v) => {
  commit(null, 'setRequestParams', { orgId: v[0] || null, page: 1, size: 8, });
  searchHandle();
};

/* 获取组织机构 */
const getOrgTree = () => {
  getOrgTreeApi().then(res => {
    if (res.code === 200 && res.status === 200) {
      orgTree.value = res.data;
    }
  });
};

const delOrgTreeNode = (id) => {
  deleteOrgTreeApi(id).then(res => {
    if (res.code === 200 && res.status === 200) {
      getOrgTree();
      message.success('操作成功');
      return;
    }
    message.error(res.detail || '操作失败!');
  });
};

/* 获取角色数据 */
const getRoleList = () => {
  dispatch(null, GET_ROLE_LIST);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  if (confirmModalConf.modalType) {
    formState.value = {};
    psdFormState.value = {};
    orgFormState.value = {};
    formRef.value.userForm.resetFields();
    psdRef.value.psdResetForm.resetFields();
    orgFormRef.value.orgForm.resetFields();
  }
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

// -------------------- 删除
/**
 * @description 删除项目
 */
const delUser = (id) => {
  // const requestData = ids.map((i) => ({ id: i, remark: confirmModalConf.remark, }));

  removeUserApi({ id: id, }).then((res) => {
    confirmModalConf.visible = false;
    confirmModalConf.title = '';
    searchHandle();
  });
};

/**
 * @description 删除项目之前
 */
const beforeDel = (id) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认删除项目？';
  confirmModalConf.callback = () => delUser(id);
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.modalType = '';
};

/**
 * @description 单行数据删除
 */
const delRecord = (record) => {
  const { userId, } = record;

  beforeDel(userId);
};

/**
 * @description 勾选删除
 */
// const selectDel = () => {
//   const ids = selectedKeys.value;

//   beforeDel(ids);
// };

// -------------------- 导出

/**
 * @description 开始导出
 */
const downloadProject = (ids) => { };

/**
 * @description 导出之前
 * @param {*} ids
 */
const beforeDownload = (ids) => {
  confirmModalConf.showRemark = false;
  confirmModalConf.title = '导出项目';
  confirmModalConf.callback = () => downloadProject(ids);
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
};

/**
 * @description 勾选导出
 */
const selectDownload = () => {
  const ids = selectedKeys.value;

  beforeDownload(ids);
};


/**
 * @description 单行数据下载excel
 */
const downRecord = (record) => {
  const { id, } = record;

  beforeDownload([id,]);
};

/* 编辑 */
const editUser = (record) => {
  formRef.value.userForm.validate().then(() => {
    delete formState.value.sysRoleList;
    delete formState.value.sysOrg;
    userUpdateApi(formState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      formState.value = {};
      submitSearch();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
const editecord = (record) => {
  let rr = record;

  rr.sysRoleIdList = [];
  record.sysRoleList.forEach(item => rr.sysRoleIdList.push(item.roleId));
  rr.sysOrgId = rr.sysOrg?.id.toString();
  formState.value = rr;
  confirmModalConf.modalType = 'edit';
  confirmModalConf.title = '修改用户';
  confirmModalConf.callback = () => editUser(rr);
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
};
/**
 * @description 新增
 */
const addData = () => {
  formRef.value.userForm.validate().then(() => {
    delete formState.value.surePassword;
    console.log(formState.value, 121212, encrypt(formState.value.password))
    formState.value.password = encrypt(formState.value.password)
    userAddApi(formState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      formState.value = {};
      submitSearch();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
const add = () => {
  confirmModalConf.modalType = 'add';
  confirmModalConf.visible = true;
  confirmModalConf.title = '新增用户';
  confirmModalConf.width = '5.4rem';
  confirmModalConf.callback = () => addData();
};

/**
* @description 新增机构
 */
const addOrgNode = () => {
  orgFormRef.value.orgForm.validate().then(() => {
    orgFormState.value.sortNum = Number(orgFormState.value.sortNum || 0);
    orgFormState.value.mineralIds = orgFormRef.value.mineralIds;
    addOrgTreeNode(orgFormState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      orgFormState.value = {};
      getOrgTree();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};

/**
* @description 编辑机构
 */
const editOrgNode = () => {
  orgFormRef.value.orgForm.validate().then(() => {
    orgFormState.value.sortNum = Number(orgFormState.value.sortNum || 0);
    orgFormState.value.mineralIds = orgFormRef.value.mineralIds;
    // console.log('editOrgNode',orgFormState.value,orgFormRef.value.mineralIds);
    editOrgTreeNode(orgFormState.value).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      orgFormState.value = {};
      getOrgTree();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
/** 打开新增机构弹窗 */
const openOrgModal = () => {
  confirmModalConf.modalType = 'addOrg';
  confirmModalConf.visible = true;
  confirmModalConf.title = '新增机构';
  confirmModalConf.width = '7rem';
  confirmModalConf.callback = () => addOrgNode();
};

/** 打开机构编辑弹窗 */
const openEditOrgModal = () => {
  confirmModalConf.modalType = 'editOrg';
  confirmModalConf.visible = true;
  confirmModalConf.title = '编辑机构';
  confirmModalConf.width = '7rem';
  confirmModalConf.callback = () => editOrgNode();
};

/* 用户角色修改 */
const roleEdit = (record) => {
  let list = [];

  confirmModalConf.sysRoleIdList.forEach(item => {
    list.push({
      id: null,
      roleId: item,
      userId: record.userId,
    });
  });
  if (list.length > 0) {
    userRoleAllocateApi(list).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      submitSearch();
    });
  }
};
const roleEditRecord = (record) => {
  record.sysRoleList.forEach(item => confirmModalConf.sysRoleIdList.push(item.roleId));
  confirmModalConf.modalType = 'roleEdit';
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.title = '用户角色修改';
  confirmModalConf.callback = () => roleEdit(record);
};
/* 密码重置 */
const rolePsdReset = (record) => {
  let data = {
    userId: record.userId,
    password: encrypt(psdFormState.value.password),
  };

  console.log(psdFormState.value.password, 1010101, encrypt(psdFormState.value.password))

  psdRef.value.psdResetForm.validate().then(() => {
    userUpdateApi(data).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.title = '';
      confirmModalConf.modalType = '';
      psdFormState.value = {};
      submitSearch();
    });
  }).catch(info => {
    console.log('Validate Failed:', info);
  });
};
const psdResetecord = (record) => {
  confirmModalConf.modalType = 'psdRest';
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.title = '密码重置';
  confirmModalConf.callback = () => rolePsdReset(record);
};

/**
 * @description 新增 或者编辑之后的回调事件
 */
const modalRequest = () => {
  searchHandle();
  dispatch('dataAudit', 'GET_MANAGEMENT_INDUSTRY_PAGE');
};


const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editecord,
    operation: [1,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1,],
  },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-jiaosexiugai',
  //     title: '角色修改',
  //   },
  //   click: roleEditRecord,
  //   operation: [1,],
  // },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-zhongzhimima',
      title: '密码重置',
    },
    click: psdResetecord,
    operation: [1,],
  },
];
const setUserType = (record, type) => {
  record.status = type
  userUpdateApi(record).then(res => {
    confirmModalConf.visible = false;
    confirmModalConf.title = '';
    confirmModalConf.modalType = '';
    formState.value = {};
    submitSearch();
  });
}
/**
 * 锁定用户
 */
const lockAccount = (record) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认锁定该用户？';
  confirmModalConf.callback = () => setUserType(record, 'PROHIBIT');
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.modalType = '';
}
/**
 * 解锁用户
 */
const unlockAccount = (record) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认解锁该用户？';
  confirmModalConf.callback = () => setUserType(record, 'NORMAL');
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.modalType = '';
}
onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  tableOperationList.value = tableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  getOrgTree();
  searchHandle();
  getRoleList();
});
// /**
//  * @description 监听requestParams条件 触发接口
//  */
// watch(
//   requestParams,
//   (val, old) => {
//     dispatch(null, GET_MANAGEMENT_INDUSTRY_PAGE);
//   },
//   {
//     deep: true,
//     immediate: true,
//   }
// );
</script>

<style lang="scss">
.institution-management-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  .left-tree-main {
    width: 2.2rem;
    height: 100%;
    overflow-y: auto;
    background: transparent;
    color: #fff;
    padding: 0.04rem;

    .tree-add-btn {
      color: #fff;
      height: 0.24rem;
      line-height: 0.24rem;
      font-size: 0.12rem;
      padding: 0 0.04rem;
      margin: 0.04rem 0 0 0.04rem;
    }

    .org-tree {
      color: #fff;

      .ant-tree-node-content-wrapper {
        color: #fff;
        font-size: 0.12rem;
      }

      .ant-tree-node-content-wrapper:hover {
        background: transparent;
      }

      .ant-tree-node-content-wrapper.ant-tree-node-selected {
        background: rgba(179, 150, 92, 0.55);
      }
    }
  }

  .role-management-main {
    height: 100%;
    width: calc(100% - 2.2rem);
    background: rgba(179, 150, 92, 0.05);

    /* 检索条件 */
    .search-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: .1rem;
      height: 0.5rem;
      margin-bottom: 0.1rem;

      .search {
        display: flex;

        .search-item {
          width: 2.2rem;
          height: 0.34rem;
          margin-right: 0.05rem;
          display: flex;

          .search-item-text {
            color: #fff;
            width: 1.1rem;
            text-align: right;
            height: 0.34rem;
            line-height: 0.34rem;
          }
        }

        /* 重置、查询操作 */
        .btn-wrapper {
          height: 0.32rem;
          line-height: 0.32rem;
          margin-left: 0.2rem;
          color: #ffffff;
          display: flex;
          padding: 0;

          .btn-item {
            width: 0.9rem;
            text-align: center;
            cursor: pointer;

            &:active {
              opacity: 0.8;
            }
          }

          .reset-btn {
            // background-color: #535962;
            background-image: url(~@/static/images/dataManagement/reset_btn.png);
            background-size: 100% 100%;
          }

          .search-btn {
            margin-left: 0.05rem;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/submit_btn.png);
            background-size: 100% 100%;
          }
        }

        /* 输入框 */
        .ant-input {
          color: white;
          background-color: rgba(91, 76, 39, 0.4);
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
          border: transparent;
        }

        .ant-input-suffix {
          width: 0.12rem;
          height: 0.12rem;
          margin-top: .02rem;
        }

        /** 下拉框 */
        .ant-select {
          width: 100%;
          height: 100%;

          .ant-select-selector {
            height: 100%;
          }

          .ant-select-arrow {
            color: #fff;
          }

          .ant-select-selection-item {
            line-height: .34rem;
          }

          // 背景
          &:not(.ant-select-customize-input) .ant-select-selector {
            background-color: rgba(91, 76, 39, 0.4);
            border: none;
            color: #fff;
          }

          /* 描述 */
          .ant-select-selection-placeholder {
            line-height: .34rem;
            color: #fff;
          }
        }
      }

      /* 增删改导按钮 */
      .crud-wrapper {
        display: flex;
        height: 0.51rem;
        padding: 0.13rem 0.1rem;

        .crud-item {
          margin-right: 0.04rem;
          width: 0.5rem;
          line-height: .25rem;
          color: #fff;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/curd_btn.png);
          background-size: 100% 100%;
          text-align: center;
        }

        .crud-item:hover {
          cursor: pointer;
        }

        .crud-item-disabled {
          pointer-events: none;
          color: rgba(255, 255, 255, 0.6);
          // background-color: rgba(239, 178, 39, 0.6);
          opacity: 0.8;
        }

        .crud-item-disabled:hover {
          cursor: no-drop;
        }
      }
    }

    /* 矿种图标 */
    .minerals-img {
      width: 0.6rem;
      height: 0.3rem;
    }


    /* 表格样式 */
    .management-table {
      height: calc(100% - 0.5rem);

      .ant-spin-container {
        display: flex;
        flex-direction: column;
        align-items: end;
      }

      .ant-spin-nested-loading,
      .ant-spin-container,
      .ant-table-content {
        height: 100%;
      }

      .ant-table {
        height: calc(100% - .70rem);
        background: none;
        padding-left: 0.1rem;

        .ant-table-scroll {
          height: 100%;
          overflow: visible;
          overflow-x: visible;

          .ant-table-header {
            overflow: visible !important;
            margin-bottom: 0 !important;
          }
        }

        .ant-table-header {
          background: none;
        }

        .ant-table-body {
          overflow-x: hidden !important;
          overflow-y: auto !important;
          background: none;
        }

        /* 矿种 */
        .primary-commodity-img {
          width: 0.8rem;
          height: 0.6rem;
        }

        /* 图标 */
        .action-icons {
          i {
            font-size: 0.22rem;
            margin-right: 0.04rem;
            cursor: pointer;
          }
        }

        .ant-table-thead {
          border: .01rem solid #4d3f1c;
          border-radius: .10rem .10rem 0rem 0rem;
          background: none;
        }

        .ant-table-thead>tr>th {
          color: #dccdab;
          background: rgba(179, 150, 92, 0.2);
          border: none;
        }

        .ant-table-tbody>tr>td {
          background-color: transparent;
          color: #fff;
          border-bottom: .01rem solid rgba(179, 150, 92, 1);
          vertical-align: middle;
        }

        .ant-table-placeholder {
          height: 100%;
          background-color: rgba(77, 63, 28, 1);
          border-top: rgba(179, 150, 92, 1);
          border-bottom: rgba(179, 150, 92, 1);
        }

        .ant-empty-normal {
          color: rgba(179, 150, 92, 1);
        }

        // 暂无数据填充样式
        // .ant-empty-img-simple-path {
        //   fill: rgba(77, 63, 28, 1);
        // }
        // .ant-empty-img-simple-ellipse {
        //   fill: rgba(77, 63, 28, 1);
        // }
        .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-thead>tr:hover.ant-table-row-selected>td,
        .ant-table-tbody>tr:hover.ant-table-row-selected>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-tbody>tr.ant-table-row-selected td {
          background-color: rgba(77, 63, 28, 1);
          color: #fff;
        }
      }
    }
  }
}
</style>
